<template>
    <!-- <section class="signature"> -->
    <div class="signatureBox">
        <span>{{ $t('labelTitle.Digital Signature') }}</span>
        <div class="w-100 uk-flex uk-flex-center">
            <div class="canvasBox" ref="canvasHW">
                <canvas ref="canvasF" @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd" @mousedown="mouseDown" @mousemove="mouseMove" @mouseup="mouseUp"></canvas>
            </div>
        </div>
        <div class="btnBox">
            <el-button type="warning" @click="overwrite">{{ $t('buttonTitle.Rewrite') }}</el-button>
            <el-button type="primary" @click="saveSignature">{{ $t('buttonTitle.Submit And Save Signature') }}</el-button>
            <el-button type="primary" @click="commit">{{ $t('buttonTitle.Submit') }}</el-button>
        </div>
    </div>
</template>

<script>
import { shareSignatureSave } from '@/api/modules/public.js'
import { compressImage } from '@/utils/file/image'
import { CONST_SIGNATURE_HEIGHT, CONST_SIGNATURE_WIDTH } from '@/common/constant'

export default {
  data () {
    return {
      points: [],
      canvasTxt: null,
      startX: 0,
      startY: 0,
      moveY: 0,
      moveX: 0,
      endY: 0,
      endX: 0,
      w: null,
      h: null,
      stageInfo: '',
      personalInfo: {},
      isDown: false
    }
  },
  mounted () {
    this.personalInfo = this.$store.state.userInfo.user
    this.$nextTick(() => {
      const canvas = this.$refs.canvasF
      canvas.height = this.$refs.canvasHW.offsetHeight
      canvas.width = this.$refs.canvasHW.offsetWidth
      this.canvasTxt = canvas.getContext('2d')
      this.stageInfo = canvas.getBoundingClientRect()
      this.canvasTxt.lineWidth = 5
    })
  },
  methods: {
    // mobile
    touchStart (ev) {
      ev = ev || event
      ev.preventDefault()
      if (ev.touches.length == 1) {
        const obj = {
          x: ev.targetTouches[0].clienX,
          y: ev.targetTouches[0].clientY
        }
        this.startX = obj.x
        this.startY = obj.y
        this.canvasTxt.beginPath()

        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(obj.x, obj.y)
        this.canvasTxt.stroke()
        this.canvasTxt.closePath()
        this.points.push(obj)
      }
    },
    touchMove (ev) {
      ev = ev || event
      ev.preventDefault()
      if (ev.touches.length == 1) {
        const obj = {
          x: ev.targetTouches[0].clientX - this.stageInfo.left,
          y: ev.targetTouches[0].clientY - this.stageInfo.top
        }
        this.moveY = obj.y
        this.moveX = obj.x
        this.canvasTxt.beginPath()
        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(obj.x, obj.y)
        this.canvasTxt.stroke()
        this.canvasTxt.closePath()
        this.startY = obj.y
        this.startX = obj.x
        this.points.push(obj)
      }
    },
    touchEnd (ev) {
      ev = ev || event
      ev.preventDefault()
      if (ev.touches.length == 1) {
        const obj = {
          x: ev.targetTouches[0].clientX - this.stageInfo.left,
          y: ev.targetTouches[0].clientY - this.stageInfo.top
        }
        this.canvasTxt.beginPath()
        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(obj.x, obj.y)
        this.canvasTxt.stroke()
        this.canvasTxt.closePath()
        this.points.push(obj)
      }
    },
    // pc
    mouseDown (ev) {
      ev = ev || event
      ev.preventDefault()
      if (1) {
        const obj = {
          x: ev.offsetX,
          y: ev.offsetY
        }
        this.startX = obj.x
        this.startY = obj.y
        this.canvasTxt.beginPath()
        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(obj.x, obj.y)
        this.canvasTxt.stroke()
        this.canvasTxt.closePath()
        this.points.push(obj)
        this.isDown = true
      }
    },
    mouseMove (ev) {
      ev = ev || event
      ev.preventDefault()
      if (this.isDown) {
        const obj = {
          x: ev.offsetX,
          y: ev.offsetY
        }
        this.moveY = obj.y
        this.moveX = obj.x
        this.canvasTxt.beginPath()
        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(obj.x, obj.y)
        this.canvasTxt.stroke()
        this.canvasTxt.closePath()
        this.startY = obj.y
        this.startX = obj.x
        this.points.push(obj)
      }
    },
    mouseUp (ev) {
      ev = ev || event
      ev.preventDefault()
      if (1) {
        const obj = {
          x: ev.offsetX,
          y: ev.offsetY
        }
        this.canvasTxt.beginPath()
        this.canvasTxt.moveTo(this.startX, this.startY)
        this.canvasTxt.lineTo(obj.x, obj.y)
        this.canvasTxt.stroke()
        this.canvasTxt.closePath()
        this.points.push(obj)
        this.points.push({ x: -1, y: -1 })
        this.isDown = false
      }
    },
    // 重写
    overwrite () {
      this.canvasTxt.clearRect(0, 0, this.$refs.canvasF.width, this.$refs.canvasF.height)
      this.points = []
    },
    // 提交保存签名
    saveSignature () {
      const image = this.$refs.canvasF.toDataURL()
      compressImage(image, CONST_SIGNATURE_WIDTH, CONST_SIGNATURE_HEIGHT).then(base64 => {
        this.imgUrl = base64
        const idval = {
          isSave: 1
        }
        if (window.opener.changeIsSave) {
          window.opener.changeIsSave(1)
        }
        this.submitSign(idval)
      })
    },
    // 提交
    commit () {
      const image = this.$refs.canvasF.toDataURL()
      compressImage(image, CONST_SIGNATURE_WIDTH, CONST_SIGNATURE_HEIGHT).then(base64 => {
        this.imgUrl = base64
        const idval = {
          isSave: 0
        }
        if (window.opener.changeIsSave) {
          window.opener.changeIsSave(0)
        }
        this.submitSign(idval)
      })
    },
    // 提交签名接口
    submitSign (val) {
      const vid = {
        // userId: this.personalInfo.id,
        isSave: val.isSave,
        signature: this.imgUrl
      }
      shareSignatureSave(vid).then(({ result, state }) => {
        if (result.resultCode === '200') {
          this.$message.success($t('integration.saved_successfully'))
          // if (val.isSave === 1) {
          //   window.opener.writeFn(window, vid.signature)
          // } else {
          window.opener.writeFn(window, result.resultKey, vid.signature)

          // }
        } else if (result.resultCode === '500') {
          this.$message.error($t('integration.save_failed'))
        } else {
          this.$message.error(state.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.signatureBox {
    width: 100%;
    height: 100%;
    // margin: 100px auto;
    padding: 10px;
    box-sizing: border-box;
    overflow: hidden;
    background: #fff;
    z-index: 100;
    text-align: center;
    border: 1px solid #eee;

    span {
        display: inline-block;
        font-size: 18px;
        font-weight: bold;
    }
}

.canvasBox {
    box-sizing: border-box;
    margin-top: 20px;
    width: 660px;
    height: 270px;
    canvas {
        width: 100%;
        margin-left: 0;
        box-sizing: border-box;
        border: 1px solid #eee;
    }
}

.btnBox {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
